import { Link } from 'react-router-dom'
import logo from '../../media/logo/logo.png'
import classes from './Footer.module.scss'

const navLinks = [
    { name: "Dashboard", link: "/"},
    { name: "Auction", link: "/auction"},
    { name: "Dealer Stock", link: "/dealer-stock"},
    { name: "My Garage", link: "/garage"},
    { name: "Guide", link: "/guide"},
    { name: "Contact us", link: "/contact"}
]

const navLink2 = [
    { name: "Terms & Conditions", link: "/terms" },
    { name: "Privacy Policy", link: "/privacy" },
    { name: "Shipping & Returns", link: "/shipping" }
]

const Footer = () => {

    return (
        <div className={classes.outerDiv}>

            <div className={classes.innerDiv}>
                {/* LogoDiv */}
                <div className={classes.LogoDiv}>
                    <div>
                        <img src={logo} alt='LOGO'/>
                    </div>
                    <p>501 Church Street NE Vienna, Virginia 22180</p>
                </div>
                {/* NavDiv */}
                <div className={classes.NavDiv}>
                    <nav>
                        {navLinks.map(navlink => 
                            <Link key={navlink.name} to={navlink.link}>{navlink.name}</Link>
                        )}
                    </nav>
                </div>
                {/* IconsDiv */}
                <div className={classes.IconsDiv}>
                    <i className="fa-brands fa-facebook"></i>
                    <i className="fa-brands fa-instagram"></i>
                    <i className="fa-brands fa-x-twitter"></i>
                    <i className="fa-brands fa-linkedin"></i>
                </div>
            </div>
            <div className={classes.divider} />
            <div className={`${classes.innerDiv} ${classes.bottomDiv}`}>
                {/* CopyDiv */}
                <div className={classes.CopyDiv}>
                    <p>© Copyright {new Date().getFullYear()} All Rights Reserved Magic Motorsports</p>
                </div>
                {/* NavDiv2 */}
                <div className={classes.NavDiv2}>
                    <nav>
                        {navLink2.map(navlink => 
                            <Link key={navlink.name} to={navlink.link}>{navlink.name}</Link>
                        )}
                    </nav>
                </div>
                {/* ContactDiv */}
                <div className={classes.ContactDiv}>
                    <div className={classes.contactButton}>
                        <i className="fa-solid fa-envelope"></i>
                        <p>sales@magicmotorsports.xyz</p>
                    </div>
                    <div className={classes.contactButton}>
                        <i className="fa-solid fa-phone"></i>
                        <p>703-249-9922</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer